import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\TKsBox\\Projects\\BuildCredits\\Web Application\\buildcredits\\node_modules\\lucide-react\\dist\\esm\\Icon.mjs");
;
import(/* webpackMode: "eager" */ "C:\\TKsBox\\Projects\\BuildCredits\\Web Application\\buildcredits\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\TKsBox\\Projects\\BuildCredits\\Web Application\\buildcredits\\src\\app\\components\\LandingFAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\TKsBox\\Projects\\BuildCredits\\Web Application\\buildcredits\\src\\components\\PublicNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\TKsBox\\Projects\\BuildCredits\\Web Application\\buildcredits\\src\\components\\ui\\AppLogo.tsx");
